import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./landing.css";
import { getAuthSnapshot, subscribeToAuthChanges } from "../auth/authUtils";

import HeroSection from "./HeroSection";
import FeaturesSection from "./FeaturesSection";
import SignalsSection from "./SignalsSection";
import ExchangesSection from "./ExchangesSection";
import PricingSection from "./PricingSection";
import TutorialsSection from "./TutorialsSection";
import FooterSection from "./FooterSection";
import SignalsPreviewSection from "./SignalsPreviewSection";

const EnterpriseLandingPage = () => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(() => getAuthSnapshot().isLoggedIn);

  useEffect(() => subscribeToAuthChanges(({ isLoggedIn: nextIsLoggedIn }) => {
    setIsLoggedIn(nextIsLoggedIn);
  }), []);

  return (
    <div className="landing-root">
<header className="landing-header">
  <div className="header-left" />

  <h2 className="brand-title header-center">
    SignalFly Global
  </h2>

  <div className="header-right">
    {isLoggedIn && (
      <button onClick={() => navigate("/app")}>
        Go to App
      </button>
    )}
  </div>
</header>



      <HeroSection />
      <SignalsPreviewSection />
      <FeaturesSection />
      <SignalsSection />
      <ExchangesSection />
      <PricingSection />
      <TutorialsSection />
      <FooterSection />
    </div>
  );
};

export default EnterpriseLandingPage;
